import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InvoiceService } from '../../../../../services/invoice.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-service-payment-history',
  templateUrl: './service-payment-history.component.html',
  styleUrls: ['./service-payment-history.component.scss'],
  providers: [MessageService]
})
export class ServicePaymentHistoryComponent implements OnInit {
  @Input() partner;
  @Input() invoice;

  public countryData: any = {};
  public paymentHistory: any = [];

  public busySyncing: boolean = false;
  public busyLoading: boolean = false;
  public hasRefund: boolean = false;
  public canRefund: boolean = false;
  public showInitiateRefundDialog : boolean = false;

  constructor(
    private invoiceService: InvoiceService,
    private helpersService: HelpersService,
    private posIntegrationService: PosIntegrationService,
    public messageService: MessageService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    this.getPayments();

  }

  getPayments() {
    this.busyLoading = true;
    this.invoiceService
      .getPaymentHistory(this.partner.ID, this.invoice.JobcardID)
      .subscribe(
        (res) => {
          this.paymentHistory = res;
          this.busyLoading = false;
          var paymentsTotal = 0;
          var refundsTotal = 0;
          this.paymentHistory.filter((x:any)=>{return x.paymentMethod === "STRIPE"}).forEach(payment => {
            paymentsTotal += payment.amountPaid;
            if(payment.refunds && payment.refunds.length > 0){
              this.hasRefund = true;            
              refundsTotal += payment.refunds.map((x:any)=>{return x.amountRefunded}).reduce((acc, num) => acc + num, 0);  
            }
            if(payment.paymentMethod === "STRIPE"){
              this.canRefund = true;
            }
          });
          if(this.canRefund && refundsTotal >= paymentsTotal){
            this.canRefund = false;
          }
          if (this.partner.AllowRefunds == false)
            this.canRefund = false;
        },
        (err) => {
          this.busyLoading = false;
        },
      );
  }

  syncPayments() {
    this.busySyncing = true;
    if(this.helpersService.getPartnerData().POSSystemID <= 10){
      this.posIntegrationService.syncWorkshopPOSPayments(this.partner.ID, this.invoice.JobcardID).subscribe(res=>{
        //this.reloadReservation.emit({});      
        this.getPayments();
        this.busySyncing = false;
      },err=>{
        this.busySyncing = false;
      });
    }else{
      this.posIntegrationService.syncNewWorkshopPOSPayments(this.partner.ID, this.invoice.ID).subscribe(res=>{
        //this.reloadReservation.emit({});      
        this.getPayments();
        this.busySyncing = false;
      },err=>{
        this.busySyncing = false;
      });
    }
  }

  canHandlePayments() {
    return this.partner.POSSystemID === 3 || this.partner.POSSystemID === 6 || this.partner.POSSystemID === 9 || this.partner.POSSystemID === 12 || this.partner.POSSystemID === 17 || this.partner.POSSystemID === 19;
  }

  noPOSSolution() {
    return this.partner.POSSystemID <= 0;
  }

  initiateRefund(){
    this.showInitiateRefundDialog = true;
  }

  refundComplete(){
    this.showInitiateRefundDialog = false;
    this.getPayments();
    this.messageService.add({
      life: 5000,
      detail: this.translate.instant(
        'bikeshop.modal.initiate_refund.refund_complete'
      ),
    });
  }
}
